import { ImageName } from "@mcleod/images";
import { Label, Layout, TableRow } from "@mcleod/components";
import { StatusErrorQuickInfo } from "./StatusErrorQuickInfo";

export class DataFusionListUtil {
    static setErrorsLabelColor(event, isError: boolean) {
        const row = event.target as TableRow;
        const label = (isError ? row?.owner?.labelErrors : row?.owner?.labelWarnings) as Label;

        if (!label) return; // Defensive check

        this.setStatusErrorTooltipDynamicContent(label, isError);

        // Get the actual count from multiple sources to ensure we have the data
        const boundRow = label.boundRow || row?.data;
        const eventTargetRow = (event.target as any)?.data || (event.target as any)?.boundRow;
        const fieldName = isError ? "error_count" : "warning_count";

        // Try to get the count value from various sources
        let countValue = boundRow?.get(fieldName) || eventTargetRow?.get(fieldName);

        // If still no value, try getting it from the table row data directly
        if (!countValue && row && row.data) {
            countValue = row.data.get(fieldName);
        }

        // Set default styling (no errors/warnings)
        label.imageName = ImageName.circleCheckEmpty;
        label.color = "success";

        // Check if there are errors/warnings using the data
        // Also fallback to label text if bound data is not available yet
        const hasIssues = (countValue && countValue !== "0 Errors" && countValue !== "0 Warnings") ||
                          (label.text && label.text !== "0 Errors" && label.text !== "0 Warnings");

        if (hasIssues) {
            label.imageName = isError ? ImageName.circleErrorSolid : ImageName.circleError;
            label.color = isError ? "error" : "warning";
        }
    }

    static setStatusErrorTooltipDynamicContent(label: Label, isError: boolean) {
        label.tooltipDynamicContent = async () => {
            // Get the actual count from the bound data instead of relying on label text
            const boundRow = label?.boundRow;
            const fieldName = isError ? "error_count" : "warning_count";
            const countValue = boundRow?.get(fieldName);

            // Check if there are errors/warnings using the bound data
            // Also fallback to label text if bound data is not available yet
            const hasIssues = (countValue && countValue !== "0 Errors" && countValue !== "0 Warnings") ||
                            (label.text && label.text !== "0 Errors" && label.text !== "0 Warnings");

            if (hasIssues && boundRow) {
                const layout = await Layout.getLoadedLayout("lme/datafusion/StatusErrorQuickInfo") as StatusErrorQuickInfo;
                if (layout.sourceEdiMapError != null) {
                    const statusId = boundRow.get("id");

                    // Determine parent table name based on model path
                    let parentTable = "edi_order"; // default
                    const modelPath = boundRow._modelPath;
                    if (modelPath) {
                        if (modelPath.includes("edi-order")) {
                            parentTable = "edi_order";
                        } else if (modelPath.includes("edi-billing")) {
                            parentTable = "edi_billing";
                        } else if (modelPath.includes("edistatus")) {
                            parentTable = "edistatus";
                        }
                    }

                    const searchFilter = {
                        parent_id: statusId,
                        parent_tablename: parentTable,
                        error_type: isError ? 'E' : 'W'
                    };
                    await layout.sourceEdiMapError.search(searchFilter);
                }

                // Set the title text immediately when we get the layout
                const titleText = isError ? 'Error Description' : 'Warning Description';

                // Force update the title after a short delay to ensure tooltip is rendered
                if (layout.labelErrorDescriptionTitle) {
                    layout.labelErrorDescriptionTitle.text = titleText;
                }
                return layout;
            }
            return null;
        };
    }
}
